import { urls } from "../api/api.urls";
import { makeParams, makeRequestBaseUrl } from "../api/make.request";

export default class AdminServiceV2 {
  static async getCenters(examId: string) {
    return await makeRequestBaseUrl(urls.adminV2.getCenters + "/" + examId, "get");
  }

  static async getCenterInvList(examId: string) {
    return await makeRequestBaseUrl(urls.adminV2.getCenterInvList + "/" + examId, "get");
  }

  static async creaetCenterInv(examId: string) {
    return await makeRequestBaseUrl(urls.adminV2.createCenterInvList + "/" + examId, "post");
  }

  static async getExamMapping(examId: any) {
    return await makeRequestBaseUrl(urls.adminV2.getExamMapping + "/" + examId, "GET")
  }

  static async getVendorSessions(examId: any, url: any, token: any) {
    const params = makeParams([
      {
        index: "url",
        value: url
      },
      {
        index: "token",
        value: token
      }
    ])
    return await makeRequestBaseUrl(urls.adminV2.getVendorSessions + "/" + examId + params, "GET")
  }

  static async createMhcetMapping(examId: any, payload: any) {
    return await makeRequestBaseUrl(urls.adminV2.createMhcetMapping + "/" + examId, "POST", payload)
  }

  static async updateMhcetMapping(examId: any, mappingId: any, payload: any) {
    return await makeRequestBaseUrl(urls.adminV2.updateMhcetMapping + "/" + examId + "/" + mappingId, "PUT", payload)
  }
  
  static async getShiftExport(shiftId: any) {
    return await makeRequestBaseUrl(urls.adminV2.getShiftExport + "/" + shiftId, "GET")
  }

  static async startSync(examId: any, shiftId: any) {
    return await makeRequestBaseUrl(urls.adminV2.startSync + "/" + examId + "/" + shiftId, "POST")
  }

  static async mapShiftToDB(examId: any, shiftId: any, payload: any) {
    return await makeRequestBaseUrl(urls.adminV2.mapShiftToDB + "/" + examId + "/" + shiftId, "PUT", payload)
  }
}
